var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownvote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0566 14.1829C15.5174 15.6099 15.75 16.8591 15.75 17.9361C15.75 20.3348 14.811 22.1835 13.25 22.1835C12.4503 22.1835 12.1721 21.7338 11.8675 20.637L11.5977 19.6155C11.4968 19.2568 11.321 18.646 11.0707 17.7845C11.064 17.7614 11.0542 17.7397 11.0413 17.7196L8.17457 13.2339C7.49652 12.173 6.49605 11.3575 5.32017 10.9073L4.06293 10.4259C3.26956 10.1222 2.80894 9.29248 2.97066 8.45848L3.65682 4.9198C3.82396 4.05782 4.47726 3.37181 5.33006 3.16279L13.5796 1.14086C16.1108 0.520467 18.6692 2.0554 19.3131 4.58073L20.8869 10.7534C21.2622 12.2251 20.3733 13.7224 18.9016 14.0976C18.6796 14.1542 18.4513 14.1829 18.2222 14.1829H15.0566Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownvote);
export default __webpack_public_path__ + "static/media/downvote.a37f32e8.svg";
export { ForwardRef as ReactComponent };